import { gql } from '@apollo/client';

export const LOGIN_USER = gql`
    query ConnectPresta($email: String!, $password: String!) {
        ConnectPresta(email: $email, password: $password) {
            response
            token
        }
    }
`

export const USER_ROLES = gql`
    query getPrestaRoles($email: String!) {
        getPrestaRoles(email: $email) {
            isCustomer
            isSubcontractor
        }
    }
`

export const TEST_CALL = gql`
    query testCall($test: String) {
        testCall(test: $test) {
            response
        }
    }
`

export const GET_CHECKOUT_DETAIL = gql`
    query getCheckoutDetails($eventId: String!) {
        getCheckoutDetails(eventId: $eventId) {
            ratingAppart,
            ratingCleanness,
            ratingOiqia,
            feedBack,
            checkoutDone,
            checkoutQuestion {
                text,
                checked
            },
            problem {
                description,
                image
            }
        }
    }
`

export const GET_PRESTA_APPART = gql`
    query {
        getPrestaAppart {        
            appartements {
                appartId
                oiqiaLabel
            } 
        }       
    }
`

export const GET_CUSTOMER_APPART = gql`
    query {
        getCustomerAppart {        
            appartements {
                appartId
                oiqiaLabel
            } 
        }       
    }
`

export const GET_PRESTA_CONSUMMABLE = gql`
    query {
        getPrestaConsummable {        
            achats {
                _id
                totalPriceTTC
                purchaseDate
                purchaseDateString
                url
            } 
        }       
    }
`

export const GET_PRESTA_CONSUMMABLE_NEW = gql`
    query {
        getPrestaConsummableNew {        
            achats {
                _id
                totalPriceTTC
                purchaseDate
                purchaseDateString
                url
            } 
        }       
    }
`


export const GET_BOOKING_CALENDAR = gql`
    query getBookingCalendar($Month: String!) {
        getBookingCalendar(Month: $Month) {
            allBooking {
                arrivalDate
                departureDate
                checkIn
                checkOut
                appartName
                bookingId
                firstName
                lastName
                lineColor
                bookingStep {
                    status
                }
            }
            events {
                date
                period {
                    startingDay
                    endingDay
                    color
                }
            }
        }
    }
`

export const GET_BOOKING_EVENT = gql`
    query getBookingEvent($day: String!) {
        getBookingEvent(day: $day) {
            bookingDay {
                id
                name
                description
                endDate
                startDate
                appartName
                startHour
                endHour
                appartId
                bookingExtId
                colorCircle
                canceled
                dateStart
                dateEnd
            }
        }
    }
`

export const GET_BOOKING_DETAIL = gql`
    query getBookingDetails($bookingId: String!, $lang: String){
        getBookingDetails(bookingId: $bookingId, lang: $lang) {
            booking {
                firstName
                lastName
                startDate
                endDate
                endHour
                startHour
                endDate
                tel
                adults
                children
                origin
                totalPrice
                basePrice
                cleaningFee
                intervention
            }
            appartInfo {
                name
                pictures {
                    name
                    url
                }
                address {
                    streetNumber
                    street
                    city
                    zipCode
                    country
                    extra
                }
                welcomeNotes {
                    name
                    url
                }
                manuels {
                    name
                    url
                }
                rules {
                    name
                    url
                }
                caracts {
                    wifiName
                    wifiCode
                    salon {
                        type
                        text
                    }
                    bedroom {
                        name
                        value {
                            type
                            text
                        }
                    }
                    bathroom {
                        type
                        text
                    }
                    kitchen {
                        type
                        text
                    }
                    outside {
                        type
                        text
                    }
                    comfort {
                        type
                        text
                    }
                    access {
                        type
                        text
                    }
                }
                description
            }
        }
    }
`

export const GET_MARKED_EVENTS = gql`
query getMarkedEvent($date: String!) {
    getMarkedEvent(date: $date) {
        events {
            name
            description
            date
            lastStatus
        }
    }
}
`

export const GET_EVENT_DETAIL = gql`
query getDetailOfEvent($eventId: String!, $lang: String!) {
  getDetailOfEvent(eventId: $eventId, lang: $lang) {
    booking {
      firstName
      lastName
      startDate
      endDate
      startHour
      endHour
    }
    todoListAppart {
      text
    }
    eventDetail {
        finish
        nameOfAppart
        title
        type
        description
        start
        end
        statusOfEvent {
          value
          createdAt
      }
      responsable
      todoList {
        text
      }
      problems {
        image
        title
        description
      }
      validationPicture {
        commentary
        image {
            container
            name
            title
        }
      }
    }
  }
}
`

export const GET_EVENT_MONTH = gql`
query getEventOfMonth($date: String!){
  getEventOfMonth(date: $date) {
    events {
      title
      timeZone
      startDate
      endDate
      location
      notes
    }
  }
}
`

export const GET_PRESTA_INFO = gql`
query {
    getPrestaInfo {
        firstName
        lastName
        phone
        email
    }
}
`

export const GET_PRESTA_INVOICES = gql`
query{
    getCompanyInvoices{
      invoices {
        date
        total
        public_path
        paid_date
      }
    }
}
`

export const GET_BOOKING_REQUEST = gql`
query{
    getBookingRequest{
        bookingRequest{
            _id
            userId
            appartName
            startDate
            endDate
            status
            reason
        }
    }
}
`

export const GET_INVOICE_DETAIL = gql`
query GetInvoiceDetail($date: String!) {
    OA_getInvoiceDetail(date: $date) {
      revenues
      revenuesDetails {
        label
        amount
      }
      expenses
      expensesDetails {
        label
        amount
      }
    }
  }
`;

export const GET_MONTHLY_DATA = gql`
query GetMonthlyData($date: String!) {
    OA_getMonthlyData(date: $date) {
        label
        value
    }
}
`;

export const GET_AVAILABLE_INVOICE_MONTHS = gql`
query OA_getAvailableInvoiceMonths {
  OA_getAvailableInvoiceMonths {
    label
    value
  }
}
`;